import secondRequest from '../_network/secondRequest'
import {locationMall} from '../_helpers'

const getVoucher = (payload) => {
    return secondRequest({
        url:'router/' + locationMall(payload.memberType) + `/voucher/list?${payload}`,
        method: 'GET'
    })
}
export const voucherServices = {
    getVoucher
}

